import React from "react";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";

export function DueDateModal({ isOpen, disableBtnDueDate, onSave, onClose }) {
  return (
    <Modal isOpen={isOpen} contentLabel="Add Note" className="confirm-modal">
      <div className="card">
        <button onClick={onClose} className="confirm-modal-close">
          <MdClose />
        </button>
        <div className="card-header">Due Date</div>
        <div className="card-body">
          Are you sure you want to change the due date?
        </div>
        <div className="card-footer">
          <button
            data-testid="save-due-date"
            disabled={disableBtnDueDate}
            type="button"
            className="btn btn-outline-primary"
            onClick={onSave}
          >
            Save
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
}
